<template>
  <div class="container-fluid max-container">
    <div class="row">
      <Header />
      <section>
        <div class="container">
          <div class="archaic-upgrade-container-fluid">
            <!-- Heading Component starts here -->
            <div class="heading-row my-3">
              <h1>Neanderthals</h1>
            </div>
            <!-- Heading Component ends here -->

            <!-- Wrapper component starts here -->
            <div class="ancestry-neatherland-row-wrapper">
              <!-- Banner Component starts here -->
              <div class="banner-neatherland-row">
                <div class="row">
                  <div class="col-lg-7">
                    <div class="banner-row-content">
                      <h1>Unlock your Archaic past today.</h1>
                      <p>
                        Explore in depth how much of your DNA is attributed to Neanderthal
                        and Denisovan humans
                      </p>
                      <h3>Only $20</h3>
                      <button>Get Started</button>
                    </div>
                  </div>
                  <div
                    class="col-lg-5 d-flex flex-column align-items-end justify-content-end"
                  >
                    <div class="banner-img-neatherland">
                      <img :src="BannerImage" alt="" />
                    </div>
                  </div>
                </div>
              </div>
              <!-- Banner Component ends here -->

              <!-- Second Component starts here -->
              <div class="archaic-ancestry my-5 rounded-4">
                <p>Archaic Ancestry</p>
                <h2>
                  Discover your Genetic <br />
                  similarity to Archaic Humans
                </h2>

                <div class="row mt-5">
                  <div class="col-lg-6">
                    <div class="archaic-ancestry-wrapper">
                      <p>
                        Ever wondered how ancient your physical characteristics are? Did
                        they benefit your ancestors to hunt, find food or a partner. We
                        can show you which of your genetically influenced physical
                        characteristics are derived from Archaic Human DNA.
                      </p>

                      <h3>Neanderthal & Denisovan scores</h3>
                      <p>
                        Your scores represents the number of alleles (DNA letters) that
                        you share with Neanderthals and Denisovans.
                      </p>

                      <h3>Closest Sample</h3>
                      <p>
                        Find out which Archaic Human DNA remnant is most similar to yours
                      </p>

                      <h3>Percentiles</h3>
                      <p>
                        Compare your level of Neanderthal DNA with the rest of our
                        userbase, as a whole and by region.
                      </p>

                      <h3>Traits</h3>
                      <p>
                        Explore your physical characteristics that originated in Archaic
                        Humans.
                      </p>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="ancestry-neatherland-image-container">
                      <img :src="AncestryImage" alt="" />
                    </div>
                  </div>
                </div>
              </div>
              <!-- Second Component ends here -->
            </div>
            <!-- Wrapper component ends here -->
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import Header from "@/components/header/Header.vue";
import "../../styles/pages/archaicNeatherland.scss";
import BannerImage from "../../assets/images/Neatherland/banner-image.jpeg";
import AncestryImage from "../../assets/images/Neatherland/ancestry-neatherland.png";

export default {
  name: "AncestryNeatherLand",
  components: {
    Header,
  },
  data() {
    return {
      BannerImage,
      AncestryImage,
    };
  },
};
</script>
